<template>
  <div>
    <div class="panel-body student-view__panel-contract">
      <cancel-contract-modal
        :contract="contract"
        @close="changeModalVisibility('showCancelContract', false)"
        v-if="showCancelContract"
      />
      <create-bill-modal
        :contract="contract"
        :billing="billing"
        @close="changeModalVisibility('showCreateBillModal', false)"
        v-if="showCreateBillModal"
      />
      <change-contract-due-day-modal
        :contract="contract"
        @close="changeModalVisibility('showContractDueDayChangingModal', false)"
        v-if="showContractDueDayChangingModal"
      />
      <change-contract-value-modal
        :contract="contract"
        @close="changeModalVisibility('showChangeContractValueModal', false)"
        v-if="showChangeContractValueModal"
      />
      <div class="student-view__header-title">
        <h4><strong>Dados do contrato</strong></h4>
        <div v-if="shouldShowActions" class="dropdown">
          <button
            class="btn btn-primary dropdown-toggle"
            type="button"
            :id="`dropdown-contract-options-${contract.id}`"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="true"
          >
            Ações
            <span class="caret"></span>
          </button>
          <ul class="dropdown-menu dropdown-menu-right" :aria-labelledby="`dropdown-contract-options-${contract.id}`">
            <li>
              <a @click="changeModalVisibility('showCancelContract', true)">
                Cancelar contrato
              </a>
            </li>
            <li v-if="contract.contract_type === 'normal'">
              <a @click="changeModalVisibility('showCreateBillModal', true)">
                Criar mensalidade
              </a>
            </li>
            <li v-if="contract.contract_type === 'normal' && contract.status === 'active'">
              <a @click="changeModalVisibility('showContractDueDayChangingModal', true)">
                Alterar dia de vencimento das mensalidades
              </a>
            </li>
            <li>
              <a @click="changeModalVisibility('showChangeContractValueModal', true)">
                Alterar valor do contrato
              </a>
            </li>
          </ul>
        </div>
      </div>
      <hr class="divider divider--spaced-l-bottom">
      <div class="panel__row">
        <div class="panel__col">
          <p class="panel__title">
            Status
          </p>
          <p>{{ contract.translated_status }}</p>
        </div>
        <div class="panel__col">
          <p class="panel__title">
            Vigência
          </p>
          <p>{{ contract.end_date | formatDate }}</p>
        </div>
        <div class="panel__col">
          <p class="panel__title">
            Mensalidades
          </p>
          <p>{{ contract.installments }}</p>
        </div>
        <div class="panel__col">
          <p class="panel__title">
            Regular
          </p>
          <p>{{ contract.regular | formatBoolean }}</p>
        </div>
        <div class="panel__col">
          <p class="panel__title">
            Id
          </p>
          <p>{{ contract.id }}</p>
        </div>
      </div>
      <div class="panel__row">
        <div class="panel__col">
          <p class="panel__title">
            Desconto
          </p>
          <p>{{ contract.discount }}%</p>
        </div>
        <div class="panel__col">
          <p class="panel__title">
            Valor pago
          </p>
          <p>{{ contract.paid_value | formatCurrency }}</p>
        </div>
        <div class="panel__col">
          <p class="panel__title">
            Valor total
          </p>
          <p>{{ contract.full_value | formatCurrency }}</p>
        </div>
        <div class="panel__col">
          <p class="panel__title">
            Valor com desconto
          </p>
          <p>{{ contract.student_value | formatCurrency }}</p>
        </div>
        <div class="panel__col">
          <p class="panel__title">
            Valor sem desconto
          </p>
          <p>{{ contract.installment_without_discount | formatCurrency }}</p>
        </div>
      </div>
      <div class="panel__row">
        <div class="panel__col">
          <p class="panel__title">
            Irregular desde
          </p>
          <p v-if="contract.irregular_since">
            {{ contract.irregular_since | formatDate }}
          </p>
          <p v-else>
            -
          </p>
        </div>
        <div class="panel__col">
          <p class="panel__title">
            Observações
          </p>
          <p>{{ contract.observations || '-' }}</p>
        </div>
        <div class="panel__col">
          <p class="panel__title">
            Tipo do contrato
          </p>
          <p>{{ contract.translated_contract_type }}</p>
        </div>
      </div>
    </div>
    <bills-list :contract-id="contract.id" />
  </div>
</template>

<script>
import BillsList from './BillsList';
import CancelContractModal from './modals/CancelContractModal';
import ChangeContractDueDayModal from './modals/ChangeContractDueDayModal';
import CreateBillModal from './modals/CreateBillModal';
import ChangeContractValueModal from './modals/ChangeContractValueModal';

export default {
  data() {
    return {
      showCancelContract: false,
      showCreateBillModal: false,
      showContractDueDayChangingModal: false,
      showChangeContractValueModal: false,
    };
  },
  props: {
    contract: {
      type: Object,
      required: true,
    },
    billing: {
      type: Object,
      required: true,
    },
  },
  computed: {
    shouldShowActions() {
      return !['finished', 'canceled'].includes(this.contract.status);
    },
  },
  components: {
    BillsList,
    CancelContractModal,
    CreateBillModal,
    ChangeContractDueDayModal,
    ChangeContractValueModal,
  },
  methods: {
    changeModalVisibility(modalName, open) {
      this[modalName] = open;
    },
  },
};
</script>
